module.exports = __webpack_public_path__ + "img/btn03.fae8ab81.svg";